import React from "react"
import Container from "@/components/container"
import AllSolutions from "../all-solutions"
import * as styles from "./index.module.scss"
import cls from "classnames"

const Categories = () => {
  return (
    <div id="categories" className={styles.container}>
      <Container>
        <h1 className={cls(styles.h1, styles.title)}>TiDB 企业级解决方案</h1>
        <AllSolutions />
      </Container>
    </div>
  )
}

export default Categories
